<template>
  <el-table :data="items" style="width: 100%" size="small">
    <el-table-column label="井号" align="center" prop="pit_number">
    </el-table-column>
    <el-table-column label="井队" align="center" prop="pit_team">
    </el-table-column>
    <el-table-column
      align="center"
      prop="model_number"
      label="型号"
    ></el-table-column>
    <el-table-column align="center" prop="serial_number" label="序列号">
      <template slot-scope="scope">
        <DrillLink :no="scope.row.serial_number"></DrillLink>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="size"
      label="尺寸(mm)"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="enter_time"
      label="入井时间"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="out_time"
      label="起出时间"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_footage"
      label="进尺(m)"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_time"
      label="纯钻时间(h)"
    ></el-table-column>
    <el-table-column align="center" prop="role_names" label="操作">
      <template slot-scope="scope">
        <el-button
          v-code="23102"
          type="text"
          size="mini"
          @click="$router.push(`/report/drill_trips/${scope.row.id}`)"
          >详情</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    items: null,
  },
}
</script>